import type { CSSProperties } from 'react';

type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZE_PX: Record<SpinnerSize, number> = {
  sm: 16,
  md: 24,
  lg: 40,
};

export function Spinner({
  size = 'md',
  className = '',
  label,
}: {
  size?: SpinnerSize;
  className?: string;
  label?: string;
}) {
  const px = SIZE_PX[size];
  const style: CSSProperties = {
    width: px,
    height: px,
    borderWidth: size === 'sm' ? 2 : 3,
  };

  return (
    <span
      role="status"
      aria-label={label ?? '読み込み中'}
      className={`inline-block animate-spin rounded-full border-solid border-gray-300 border-t-blue-600 ${className}`}
      style={style}
    />
  );
}

export function LoadingState({
  message = '読み込み中...',
  className = '',
}: {
  message?: string;
  className?: string;
}) {
  return (
    <div className={`flex items-center gap-3 text-sm text-gray-500 ${className}`}>
      <Spinner size="sm" />
      <span>{message}</span>
    </div>
  );
}
